import { profile } from '@/api'

import {
	PROFILE_LOADING_STATUS,
	PROFILE_NOTES_GET,
	PROFILE_BOOKMARKS_GET,
	PROFILE_GET_ERROR,
	PROFILE_NOTES_UPDATE,
	PROFILE_EDITABLE_NOTE_UPDATE,
	PROFILE_NOTES_CLEAR,
	PROFILE_BOOKMARKS_CLEAR,
	PROFILE_GET_BOOKMARK_SPEAKERS
} from './types'
import { APP_SHOW_ALERT, APP_HIDE_ALERT } from '../app/types'

const getProfileBookmarkList = async (ctx, { source, query }) => {
	ctx.commit(PROFILE_LOADING_STATUS, true)
	try{
		const { data, headers } = await profile.getBookmarkDetailList(source,query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}
		ctx.commit(PROFILE_GET_BOOKMARK_SPEAKERS, response)
		ctx.commit(PROFILE_LOADING_STATUS, false)
	}
	catch(error) {
		ctx.commit(PROFILE_GET_ERROR, error)
	} finally {
		ctx.commit(PROFILE_LOADING_STATUS, false)
	}

}

const getProfileNotes = async (ctx, query) => {
	ctx.commit(PROFILE_LOADING_STATUS, true)

	try {
		const { data, headers } = await profile.fetchNotes(query)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(PROFILE_NOTES_GET, response)
		ctx.commit(PROFILE_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
		console.error(e)
	}
}

const getNoteById = async (ctx, query) => {
	ctx.commit(PROFILE_LOADING_STATUS, true)

	try {
		const data = await profile.fetchNoteById(query)
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
		console.log(e)
	} finally {
		ctx.commit(PROFILE_LOADING_STATUS, false)
	}
}

const addNote = async (ctx, payload) => {
	ctx.commit(PROFILE_LOADING_STATUS, true)

	try {
		const { data } = await profile.addNote(payload)
		ctx.commit(PROFILE_EDITABLE_NOTE_UPDATE, data)
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
        setTimeout(() => {
            ctx.commit(`app/${APP_HIDE_ALERT}`, '', { root: true })
        }, 5000)
		ctx.commit(
			`app/${APP_SHOW_ALERT}`,
			{ message: e.response?.data?.[0]?.message || e.message, type: 'error',},
			{ root: true }
		)
		console.log(e)
	} finally {
		ctx.commit(PROFILE_LOADING_STATUS, false)
	}
}

const updateNote = async (ctx, payload) => {
	ctx.commit(PROFILE_LOADING_STATUS, true)

	try {
		const { data } = await profile.updateNote(payload)

		ctx.commit(PROFILE_NOTES_UPDATE, data)
		ctx.commit(PROFILE_EDITABLE_NOTE_UPDATE, data)
		return true
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
		ctx.commit(
			`app/${APP_SHOW_ALERT}`,
			{ message: e.message, type: 'error', closeTimeout: 5000 },
			{ root: true }
		)
		console.error(e)
	} finally {
		ctx.commit(PROFILE_LOADING_STATUS, false)
	}
}

const deleteNote = async (ctx, payload) => {
	ctx.commit(PROFILE_LOADING_STATUS, true)

	try {
		await profile.deleteNote(payload)
		ctx.commit(PROFILE_EDITABLE_NOTE_UPDATE, null)
		const closeTimeout = setTimeout(() => {
			ctx.commit(`app/${APP_HIDE_ALERT}`, '', { root: true })
		}, 3000)
		ctx.commit(
			`app/${APP_SHOW_ALERT}`,
			{ message: 'Note has been deleted', closeTimeout },
			{ root: true }
		)
		return true
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
		console.error(e)
	} finally {
		ctx.commit(PROFILE_LOADING_STATUS, false)
	}
}

const getProfileBookmarks = async (ctx, query) => {
	ctx.commit(PROFILE_LOADING_STATUS, true)

	try {
		const { data, headers } = await profile.fetchBookmarks(query)

		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			pageCount,
			perPage,
			totalCount,
			currentPage,
		}

		ctx.commit(PROFILE_BOOKMARKS_GET, response)
		ctx.commit(PROFILE_LOADING_STATUS, false)
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
		console.error(e)
	}
}

const updateEditableNote = async (ctx, payload) => {
	try {
		ctx.commit(PROFILE_EDITABLE_NOTE_UPDATE, payload)
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
		console.error(e)
	}
}

const clearNotes = async (ctx) => {
	try {
		ctx.commit(PROFILE_NOTES_CLEAR)
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
		console.error(e)
	}
}

const clearBookmarks = async (ctx) => {
	try {
		ctx.commit(PROFILE_BOOKMARKS_CLEAR)
	} catch (e) {
		ctx.commit(PROFILE_GET_ERROR, e)
		console.error(e)
	}
}

export default {
	getProfileBookmarks,
	getProfileNotes,
	getNoteById,
	addNote,
	updateNote,
	deleteNote,
	updateEditableNote,
	clearNotes,
	clearBookmarks,
	getProfileBookmarkList
}
